import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import { RootState } from "../../../../redux/store";
import { commonAction } from "../../../../redux/features/commonSlice";
import CloseIcon from "../../../../components/icons/CloseIcon";
import { CommonEnums } from "../../../../enums/common.enums";
import { clientRoutes } from "../../../../utils/routes";

import FilterDates from "../../filter/FilterDates";
import FixDataFilterSelector from "../../filter/FixDataFilterSelector";
import "./SystemFontsFilter.scss";

const SystemFontsFilter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const homePageFilter = useSelector(
    (state: RootState) => state?.common?.homePageFilter,
  );
  const resetFilter = useSelector(
    (state: RootState) => state?.common?.resetFilter,
  );

  const onCloseFilter = () => {
    dispatch(commonAction.setHomePageFilter());
  };

  const onSubmitHandler = (values: any) => {
    const navigationString =
      `system-fonts?status=${values?.font_status || ""}` +
      `&start_date=${
        values?.startDate === "00-00-00" ? "" : values?.startDate
      }` +
      `&end_date=${values?.endDate === "00-00-00" ? "" : values?.endDate}`;

    navigate(`/${navigationString}`);
    dispatch(commonAction.resetFilter());
    onCloseFilter();
  };

  const initialValues: any = {
    status: "",
    font_status: "",
    startDate: "",
    endDate: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      status: Yup.string().optional(),
      font_status: Yup.string().optional(),
      startDate: Yup.string().optional(),
      endDate: Yup.string().optional(),
    }),
    onSubmit: onSubmitHandler,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
  });

  const onClickClear = () => {
    formik.setValues({
      status: "",
      font_status: "",
      startDate: "00-00-00",
      endDate: "00-00-00",
    });

    navigate(clientRoutes.systemFonts);
    onCloseFilter();
    dispatch(commonAction.resetFilter());
  };

  useEffect(() => {
    const status = searchParams.get("status") || "";
    const start_date = searchParams.get("start_date") || "";
    const end_date = searchParams.get("end_date") || "";

    formik.setValues({
      status,
      font_status: status,
      startDate: start_date,
      endDate: end_date,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFilter, searchParams.toString()]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className={`invites-filter-container ${
          homePageFilter ? "" : "deactivate-filter"
        }`}
      >
        {homePageFilter && (
          <div className="filter-background" onClick={onCloseFilter}></div>
        )}

        <div
          className={`invites-filter-box ${
            homePageFilter ? "" : "deactivate-filter"
          }`}
        >
          <div className="filter-top-heading">
            <p className="filter-top-head">Filters</p>
            <div className="filter-close-icon" onClick={onCloseFilter}>
              <CloseIcon />
            </div>
          </div>

          <div className="filter-body-container">
            <div className="filter-selector-container">
              <FixDataFilterSelector
                formik={formik}
                type={CommonEnums.selectorType?.font_status}
                placeholder="Status"
              />

              <FilterDates formik={formik} lable="Created date" />
            </div>
          </div>

          <div className="action-btn">
            <button
              type="button"
              className="clear-filters-btn"
              onClick={onClickClear}
            >
              Clear Filters
            </button>

            <button type="submit" className="apply-btn">
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SystemFontsFilter;